{
  /* TODO: Reimplement after routing adjustment }
  <Helmet>
    <link type="text/css" rel="stylesheet" href="css/gallery/modal.css" />
    <link type="text/css" rel="stylesheet" href="css/chosen.css" media="screen" />
    <link type="text/css" rel="stylesheet" href="css/modal_load.css" />
    <link type="text/css" rel="stylesheet" href="css/tipTip.css" />
    <link type="text/css" rel="stylesheet" href="js/jquery-ui/jquery-ui.css" />
    <link type="text/css" rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
    <link type="text/css" rel="stylesheet" href="css/index.css" />
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/babel-core/5.8.34/browser.min.js"></script>
    <script type="text/javascript" src="js/jquery-ui/jquery-ui.min.js"></script>
    <script type="text/javascript" src="js/moment.min.js"></script>
    <script type="text/javascript" src="js/moment-timezone-with-data.min.js"></script>
    <script type="text/javascript" src="js/jquery-migrate-1.2.1.min.js"></script>
    <script type="text/javascript" src="js/qrcode.js"></script>
    <script type="text/javascript" src="js/jquery.qrcode.js"></script>utopia-white.css?v=1.5.0
    <script type="text/javascript" src="js/chosen.jquery.js"></script>
    <script type="text/javascript" src="js/maskedinput.js"></script>
    <script type="text/javascript" src="js/jquery.tipTip.minified.js"></script>
    <script type="text/javascript" src="https://maxcdn.bootstrapcdn.com/bootstrap/2.2.2/js/bootstrap.min.js"></script>
  </Helmet> */
}
{
  /* TODO: Readd after implementation Content Section
  <div className='main'>
    <div id={`${this.urlPath.replace(/s\s*$/, "")}`}>
      <Router>
        <Switch>
          <Route exact path="/" />
          <Route path="/:directon" render={(props) => <RouteTemplate {...props} pageName={this.urlPath} />} />
        </Switch>
      </Router>
      <div id="unsupported-browser-message-container" style={{ display: 'none' }}>
        <div className="unsupported-browser-message" style={styles.browserMessageBox}>
          <div>You are using an unsupported browser.</div>
          <div> Supported Browsers: <span style={{ fontWeight: 600 }}> Google Chrome®, Safari®, Firefox®, Microsoft Edge™ </span></div>
        </div>
      </div>
    </div>
  </div> */
}

{
  /* TODO: Check if being used for testing somewhere
<input type="hidden" name="client_name" id="client_name" value={client_name} />
<input type="hidden" name="retailer_user_id" id="retailer_user_id" value={retailer_user_id} /> */
}
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
//components
import Button from "@components/ui/Button";
//utilities
import {
  getTimeZoneAbbr,
  convertISODateTime,
  getNowISO,
} from "@utils/time-helpers";
import { isEmptyObject } from "@utils/object-helpers";
import {
  featurePermissions,
  isURLAValidPage,
  exemptPages,
} from "@utils/navigation-helpers";
import { formatSMLoggedChanges } from "@features/schema-management/utils/schemaManagementHelpers";
// assets
import IconCircleCheck from "@assets/icons/IconCircleCheck";
import IconWarning from "@assets/icons/IconWarning";
import IconStatus from "@assets/icons/IconStatus";
import { formatErrors } from "@features/sypi/_utils/sypi-interface-helpers";
import controlcenterVersion from "AppVersion/controlcenterVersion.json";
//actions
import { setConfirmationDock } from "@actions/global";
import {
  SCHEMA_MANAGEMENT_LABELS,
  SCHEMA_MANAGEMENT_PATHNAMES,
  SYPI_BRC,
} from "@constants/schema-management";

const styles = {
  syf_navbar: "w-full font-body",
  syf_client_name: "flex justify-center m-8 mb-0 text-md-2",
  syf_unorder: "list-none m-0 p-0",
  syf_unorder_notclicked:
    "rounded-md invisible origin-top scale-y-0 transition-transform duration-300 ease-out opacity-0 absolute right-0 h-0",
  syf_unorder_clicked: "!visible !scale-y-100 !h-auto !opacity-100 !relative",
  left: "!text-left ml-[20%]",
  syf_navbar_list:
    "block text-opacity-87 text-center relative no-underline duration-100",
  syf_navbar_list_link:
    "!no-underline outline-0 p-0 items-center text-lg leading-tight tracking-[0.19px] text-black",
  index_header_name:
    "!py-[0.9rem] !px-3.5 hover:bg-color-marigold hover:rounded-md hover:cursor-pointer hover:text-white focus:bg-color-marigold focus:rounded-md focus:cursor-pointer focus:!text-white",
  line: "absolute w-16 border-b-4 border-color-teal opacity-0",
};

const elementMap = {
  sypi: {
    "sypi-content": "content",
    "sypi-style": "styles",
    "sypi-feature": "features",
    "sypi-business-rules": "businessRules",
    "sypi-instance": "instance",
    "sypi-import": "import",
  },
  sypi_brc: {
    "schema-management-sypi-brc-content": "content",
    "schema-management-sypi-brc-styles": "styles",
    "schema-management-sypi-brc-features": "features",
    "schema-management-sypi-brc-business-rules": "businessRules",
    "schema-management-sypi-brc-import": "import",
  },
};

const Sidebar = () => {
  const dispatch = useDispatch();
  const sessionDetails = useSelector((state) => state.config.sessionDetails);
  const timeZone = useSelector((state) => state.config.timeZone);
  const [sideNavPage, setSideNavPage] = useState(() => "");
  const [subPage, setSubPage] = useState("");
  const [isDropOpen, setDropDownOpen] = useState(false);
  const [nonEmptySections, setNonEmptySections] = useState({});
  const { productionFlag, logo, ctid, client_name, client_schema_management } =
    sessionDetails || {};
  const curTimeRef = useRef(null);
  const curDateRef = useRef(null);
  const sypiNewView = useSelector((state) => state?.sypiNewView);
  const schemaAllView = useSelector((state) => state?.schemaAllView);
  const validationErrors = sypiNewView
    ? sypiNewView?.validationErrors
    : schemaAllView?.validationErrors;
  const requiredErrors = sypiNewView
    ? sypiNewView?.errors
    : schemaAllView?.errors;
  const loggedChanges = schemaAllView?.loggedChanges;
  const featureName = schemaAllView?.featureName;
  const schemaManagementConfig = schemaAllView?.schemaManagementConfig;
  const pathName = window.location.pathname;
  const noClientConfig = pathName.includes(SCHEMA_MANAGEMENT_PATHNAMES.wallets)
    ? schemaManagementConfig?.length > 0
      ? schemaManagementConfig?.find(
          (config) => config?.client === "" || !config?.client
        )
      : []
    : false;
  const walletsNewClientFieldId = `root_${
    schemaManagementConfig?.length - 1
  }_client`;
  const walletsErrorPresent =
    validationErrors?.[walletsNewClientFieldId]?.newClientNameCannotBeBlank ||
    validationErrors?.[walletsNewClientFieldId]?.inputLimitError ||
    !!validationErrors?.[walletsNewClientFieldId]?.duplicateClient;

  const [combinedErrors, setCombinedErrors] = useState([]);
  const {
    syf_navbar,
    syf_client_name,
    syf_unorder,
    syf_unorder_notclicked,
    syf_unorder_clicked,
    syf_navbar_list,
    left,
    syf_navbar_list_link,
    index_header_name,
    line,
  } = styles;

  const capitalize = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

  const setActiveClass = (identifier, sideNavPage) =>
    sideNavPage === identifier ? "active-line" : "innactive-line";

  if (curTimeRef.current)
    curTimeRef.current.innerText = `Current Time: ${
      convertISODateTime(getNowISO(timeZone), timeZone).toTimeSpace
    }`;
  if (curDateRef.current)
    curDateRef.current.innerText = convertISODateTime(
      getNowISO(timeZone),
      timeZone
    ).toWordDate;
  useEffect(() => {
    const currentPage = location.pathname.split("/")[1];
    let page = isURLAValidPage(currentPage);
    if (page.subPage) {
      setDropDownOpen(true);
    }
    setSideNavPage(page.page);
    setSubPage(page.subPage);
  }, [location.pathname]);

  useEffect(() => {
    if (sessionDetails && !isEmptyObject(sessionDetails)) {
      setNonEmptySections(isDropdownSectionEmpty(featurePermissions));
    }
  }, [sessionDetails]);

  useEffect(() => {
    const secondsTimer = setInterval(() => {
      if (curTimeRef.current)
        curTimeRef.current.innerText = `Current Time: ${
          convertISODateTime(getNowISO(timeZone), timeZone).toTimeSpace
        }`;
      if (curDateRef.current)
        curDateRef.current.innerText = convertISODateTime(
          getNowISO(timeZone),
          timeZone
        ).toWordDate;
    }, 1000);
    return () => clearInterval(secondsTimer);
  }, []);

  const isDropdownSectionEmpty = (featurePermissions) =>
    featurePermissions && featurePermissions.length
      ? featurePermissions.reduce((acc, feature) => {
          let isNotEmpty = feature.hasSubPages
            ? hasAccess(sessionDetails, feature.sectionDetails) &&
              feature.subPages.filter((subPage) =>
                hasAccess(sessionDetails, subPage)
              ).length
            : hasAccess(sessionDetails, feature.sectionDetails);
          if (isNotEmpty) {
            acc[feature.sectionDetails.name] = feature.sectionDetails.name;
          }
          return acc;
        }, {})
      : {};

  const hasAccess = (sessionDetails, feature) => {
    const isAdminOrHigher =
      sessionDetails.userLevel === "admin" ||
      sessionDetails.userLevel === "superadmin";
    if (!feature.needPermission) {
      return true;
    } else if (
      feature.adminOrHigherRequired &&
      feature.superAdmin &&
      sessionDetails.userLevel === "superadmin" &&
      exemptPages[feature.featureKey]
    ) {
      return true;
    } else if (
      feature.adminOrHigherRequired &&
      isAdminOrHigher &&
      sessionDetails.featurePermissions[feature.featureKey]
    ) {
      return true;
    } else if (
      !feature.adminOrHigherRequired &&
      sessionDetails.featurePermissions[feature.featureKey]
    ) {
      return true;
    }
    return false;
  };
  const onLeavingSm = (redirectTo) => {
    let formattedLoggedChanges = formatSMLoggedChanges(loggedChanges);
    dispatch(
      setConfirmationDock({
        idTarget: redirectTo,
        title: `Undo  ${featureName || "Schema Management"} Changes `,
        message: `Moving to this tab will undo your current changes to: ${formattedLoggedChanges}. Do you wish to proceed?`,
        updateAction: "leavingSm",
      })
    );
  };

  const SubSection = ({ listItem, schema }) =>
    hasAccess(sessionDetails, listItem) ? (
      <li
        id={listItem.name}
        key={`sub-section-${listItem.name}`}
        className={`${syf_navbar_list} ${left} !ml-[10%]`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <a
          className={`${listItem.name} ${syf_navbar_list_link}`}
          onClick={() => {
            let redirectTo = !listItem.hasOwnProperty("href")
              ? `/${listItem.name}`
              : listItem.href;
            if (
              ((listItem?.featureKey === "Schema Management" &&
                listItem.name.includes("config-schedule")) ||
                listItem?.featureKey !== "Schema Management") &&
              loggedChanges &&
              loggedChanges.length
            ) {
              onLeavingSm(redirectTo);
            } else {
              setSubPage(listItem.name);
              location.href = redirectTo;
            }
          }}
          title={listItem.labelName}
        >
          <div
            className={`${index_header_name} ${
              (elementMap[schema] &&
                combinedErrors.includes(elementMap[schema][listItem.name]) &&
                ((sypiNewView && schema === "sypi") ||
                  (schemaAllView && schema !== "sypi"))) ||
              ((listItem.labelName ===
                SCHEMA_MANAGEMENT_LABELS.rewards_mfe_athos ||
                listItem.labelName ===
                  SCHEMA_MANAGEMENT_LABELS.statements_mfe_athos) &&
                combinedErrors.length)
                ? "!text-[#ff0000]"
                : ""
            } ${
              setActiveClass(listItem.name, subPage) === "active-line"
                ? "!font-bold"
                : "font-normal"
            }`}
          >
            {capitalize(listItem.labelName)}
            <div
              id="feature-line"
              className={`${line} ${
                setActiveClass(listItem.name, subPage) === "active-line"
                  ? "!opacity-100"
                  : ""
              }`}
            ></div>
          </div>
        </a>
      </li>
    ) : null;

  const convertReqError = (errors) => {
    var aErrors = [];
    if (errors)
      aErrors = Object.entries(errors)
        .filter((error) => error[1]) // Filter for errors with status of true
        .map((error) => error[0]);
    return formatErrors(aErrors);
  };

  useEffect(() => {
    if (validationErrors && requiredErrors) {
      let valErrorPages = Object.keys(validationErrors);
      let reqErrorPages = Object.keys(convertReqError(requiredErrors));
      setCombinedErrors([...new Set([...valErrorPages, ...reqErrorPages])]);
    }
  }, [validationErrors, requiredErrors]);

  let iconStyle = productionFlag
    ? {
        light: "fill-color-light-yellow-warning",
        dark: "fill-color-dark-yellow-warning",
      }
    : { light: "fill-color-light-teal", dark: "fill-color-dark-green" };
  return (
    <div className="hide-scroll-bar bg-white w-[95%] min-w-[15.5rem] py-6 px-0 overflow-x-hidden overflow-y-scroll max-h-full h-full">
      {location.pathname !== "/select-clients" &&
      sessionDetails &&
      !isEmptyObject(sessionDetails) ? (
        <div className={syf_navbar}>
          <ul className={`${syf_navbar} ${syf_unorder}`}>
            <div className={syf_client_name}>{client_name}</div>
            {logo && logo.length > 0 && (
              <li
                id="client-logo-list"
                className="flex flex-col items-center mx-14 justify-center relative"
              >
                <div
                  id="client-logo-container"
                  className="client-logo-container w-[9.25rem] max-w-[9.25rem] h-[9.25rem] max-h-[9.25rem] mt-4 mb-8 bg-color-light-gray-background rounded-[74px] grid items-center"
                >
                  <img
                    id="client-logo"
                    className="w-[80%] object-cover my-0 mx-auto h-auto rounded-[10px]"
                    src={logo}
                  />
                </div>
                <div className="top-0 absolute">
                  {client_schema_management === SYPI_BRC ? (
                    <IconStatus theme={SYPI_BRC.toUpperCase()} />
                  ) : null}
                </div>
              </li>
            )}
            {
              <li
                id="client-flag-env"
                className="client-flag flex justify-center"
              >
                <Button
                  className="client-flag-env-btn"
                  componentID="client-flag-env-btn"
                  label={`${
                    productionFlag ? "PRODUCTION" : "UAT"
                  }`.toUpperCase()}
                  ariaLabel={`${
                    productionFlag ? "PRODUCTION" : "UAT"
                  }`.toUpperCase()}
                  disable
                  customStyle={`w-47.5 h-12.3 flex items-center justify-start rounded-lg-1 border-2 border-solid mb-10 mt-4 ${
                    productionFlag
                      ? " !text-color-dark-yellow-warning !bg-color-light-yellow-warning !border-color-dark-yellow-warning"
                      : " !bg-color-light-teal !border-color-dark-green !text-color-dark-green"
                  }`}
                  theme="secondary"
                  icon={
                    productionFlag ? (
                      <IconWarning
                        outerFillColor={iconStyle.dark}
                        width="24"
                        height="24"
                        iconFillColor={iconStyle.light}
                        className="mr-4 font-extrabold"
                      />
                    ) : (
                      <IconCircleCheck
                        outerFillColor={iconStyle.dark}
                        width="24"
                        height="24"
                        className="mr-4 font-extrabold"
                      />
                    )
                  }
                  width="w-49"
                  key="btn-0"
                />
              </li>
            }
            {featurePermissions.map((feature, index) =>
              nonEmptySections[feature.sectionDetails.name] &&
              hasAccess(sessionDetails, feature.sectionDetails) ? (
                <li
                  key={`${feature.sectionDetails.name}-${index}`}
                  className={`${syf_navbar_list} ${left}`}
                  id={`syf-${feature.sectionDetails.name}`}
                  onClick={(e) => {
                    feature.hasSubPages
                      ? setDropDownOpen(
                          sideNavPage === feature.sectionDetails.name
                            ? !isDropOpen
                            : true
                        )
                      : null;
                  }}
                >
                  <a
                    className={`${feature.sectionDetails.name}-feature ${syf_navbar_list_link}`}
                    onClick={() => {
                      if (!feature.hasSubPages) {
                        let redirectTo = !feature.sectionDetails.hasOwnProperty(
                          "href"
                        )
                          ? `/${feature.sectionDetails.name}`
                          : feature.sectionDetails.href;
                        if (
                          subPage.includes("schema-management") &&
                          !subPage.includes("config-schedule") &&
                          loggedChanges &&
                          loggedChanges.length
                        ) {
                          onLeavingSm(redirectTo);
                        } else {
                          location.href = redirectTo;
                          setSideNavPage(feature.sectionDetails.name);
                          setSubPage("");
                        }
                      } else {
                        setSideNavPage(feature.sectionDetails.name);
                        setSubPage("");
                      }
                    }}
                    title={capitalize(feature.sectionDetails.name)}
                  >
                    <div
                      className={`${index_header_name}
                      ${
                        !SCHEMA_MANAGEMENT_LABELS[client_schema_management] &&
                        feature.sectionDetails.name === "schema-management"
                          ? "hidden"
                          : feature.sectionDetails.name === sideNavPage
                            ? "!font-bold"
                            : "font-normal"
                      }`}
                    >
                      {feature.sectionDetails.name === "schema-management" &&
                      client_schema_management
                        ? SCHEMA_MANAGEMENT_LABELS[client_schema_management]
                        : sideNavPage === feature.sectionDetails.name
                          ? feature.sectionDetails.labelName.toUpperCase()
                          : capitalize(feature.sectionDetails.labelName)}
                      <div
                        id="feature-line"
                        className={`${line} ${
                          setActiveClass(
                            feature.sectionDetails.name,
                            sideNavPage
                          ) === "active-line"
                            ? "!opacity-100"
                            : ""
                        }`}
                      ></div>
                    </div>
                  </a>
                  {feature.hasSubPages ? (
                    <ul
                      id={feature.sectionDetails.name}
                      className={`syf-collapse ${syf_unorder} ${syf_unorder_notclicked} ${
                        isDropOpen &&
                        sideNavPage === feature.sectionDetails.name
                          ? `${syf_unorder_clicked}`
                          : ""
                      }`}
                    >
                      {feature.subPages.map((page) =>
                        feature.sectionDetails.name === "schema-management" &&
                        page.subFeatureKey !==
                          client_schema_management ? null : (
                          <SubSection
                            listItem={page}
                            key={`sub-sction-${index}-${page.name}`}
                            schema={
                              page.subFeatureKey ? page.subFeatureKey : "sypi"
                            }
                          />
                        )
                      )}
                    </ul>
                  ) : null}
                </li>
              ) : null
            )}
            <li
              key={`additional-info`}
              className={`${syf_navbar_list} ${left} !m-0`}
              id="add-info"
            >
              <div className="w-max my-12 mx-auto">
                <p
                  id="add-info-current-time"
                  className="font-normal my-[5px] mx-0"
                >
                  <span ref={curTimeRef} />
                </p>
                <p
                  id="add-info-time-zone"
                  className="font-normal my-[5px] mx-0"
                >
                  Time Zone: {getTimeZoneAbbr(timeZone)}
                </p>
                <p id="add-info-version" className="font-normal my-[5px] mx-0">
                  Version {controlcenterVersion?.releaseVersion || "17"}
                </p>
                <p id="add-info-time" className="font-normal my-[5px] mx-0">
                  <span ref={curDateRef} />
                </p>
                <p id="add-info-ctid" className="font-normal my-[5px] mx-0">
                  CTID: {ctid}
                </p>
              </div>
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default Sidebar;
